import _find from 'lodash/find';
import axios from 'axios';
import Vue from 'vue';
import { auth } from '../utils/requests';
import { request_mutations, request_state } from '../utils/store';
import {
    SPACES_LIST,
    SPACES_AVAILABLE_LIST,
    SPACES_JOIN_REQUEST,
    SPACES_DETAIL,
    SPACES_USAGE,
    SPACE_PARTICIPANTS,
} from '../api';

export default {
    namespaced: true,
    state: {
        last_page: {},
        list: request_state(),
        create: request_state(),
        update: request_state(),
        detail: request_state(),
        remove: request_state(),
        usage: request_state(),
        participants: request_state(),
        join_request: request_state(),
        available_spaces: request_state(),
    },
    mutations: {
        ...request_mutations('spaces_list', 'list'),
        ...request_mutations('space_detail', 'detail'),
        ...request_mutations('create_space', 'create'),
        ...request_mutations('update_space', 'update'),
        ...request_mutations('remove_space', 'remove'),
        ...request_mutations('participants_list', 'participants'),
        ...request_mutations('join_request', 'join_request'),
        ...request_mutations('available_spaces_list', 'available_spaces'),
        ...request_mutations('spaces_usage', 'usage'),
        set_last_page(state, { space_id, url }) {
            state.last_page[space_id] = url;
        },
        space_detail_clear(state) {
            state.detail = request_state();
        },
        space_update_clear(state) {
            state.update = request_state();
        },
        change_request_status(state, { id, requested }) {
            const space = _find(state.available_spaces.data.results, { id });
            Vue.set(space, 'requested', requested);
        },
    },
    actions: {
        list({ commit }, params) {
            commit('spaces_list_loading');
            axios.get(SPACES_LIST, { params, ...auth() }).then((response) => {
                commit('spaces_list_success', response.data);
            }).catch((error) => {
                commit('spaces_list_error', error.response ? error.response.data : {});
            });
        },
        detail({ commit }, { space_id }) {
            const url = SPACES_DETAIL.replace('{space_id}', space_id);
            commit('space_detail_loading');

            return new Promise((resolve) => {
                axios.get(url, auth()).then((response) => {
                    commit('space_detail_success', response.data);
                    resolve(response.data);
                }).catch((error) => {
                    commit('space_detail_error', error.response ? error.response.data : {});
                });
            });
        },
        create({ commit }, data) {
            commit('create_space_loading');
            return new Promise((resolve) => {
                axios.post(SPACES_LIST, data, auth()).then((response) => {
                    commit('create_space_success', response.data);
                    resolve();
                }).catch((error) => {
                    commit('create_space_error', error.response ? error.response.data : {});
                });
            });
        },
        update({ commit }, { space_id, data }) {
            const url = SPACES_DETAIL.replace('{space_id}', space_id);
            commit('update_space_loading');
            axios.patch(url, data, auth()).then((response) => {
                commit('update_space_success', response.data);
                commit('space_detail_success', response.data);
            }).catch((error) => {
                commit('update_space_error', error.response ? error.response.data : {});
            });
        },
        remove({ commit }, { space_id }) {
            const url = SPACES_DETAIL.replace('{space_id}', space_id);
            commit('remove_space_loading');

            return new Promise((resolve) => {
                axios.delete(url, auth()).then((response) => {
                    commit('remove_space_success', response.data);
                    resolve();
                }).catch((error) => {
                    commit('remove_space_error', error.response ? error.response.data : {});
                });
            });
        },
        usage({ commit }, { space_id }) {
            const url = SPACES_USAGE.replace('{space_id}', space_id);
            commit('spaces_usage_loading');

            axios.get(url, auth()).then((response) => {
                commit('spaces_usage_success', response.data);
            }).catch((error) => {
                commit('spaces_usage_error', error.response ? error.response.data : {});
            });
        },
        participants({ commit }, {
            space_id,
            search,
            exclude_ids,
            hide_admins = false,
        }) {
            const url = SPACE_PARTICIPANTS.replace('{space_id}', space_id);
            commit('participants_list_loading');
            const params = { search, exclude_ids, hide_admins };

            axios.get(url, { params, ...auth() }).then((response) => {
                commit('participants_list_success', response.data);
            }).catch((error) => {
                commit('participants_list_error', error.response ? error.response.data : {});
            });
        },
        available_spaces({ commit }, params) {
            commit('available_spaces_list_loading');
            axios.get(SPACES_AVAILABLE_LIST, { params, ...auth() }).then((response) => {
                commit('available_spaces_list_success', response.data);
            }).catch((error) => {
                commit('available_spaces_list_error', error.response ? error.response.data : {});
            });
        },
        join_request({ commit }, { space_id }) {
            const url = SPACES_JOIN_REQUEST.replace('{space_id}', space_id);

            commit('join_request_loading');
            return new Promise((resolve) => {
                axios.post(url, {}, auth()).then((response) => {
                    commit('join_request_success', response.data);
                    resolve();
                }).catch((error) => {
                    commit('join_request_error', error.response ? error.response.data : {});
                });
            });
        },
    },
};
